import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import Select from "react-select";

import {
  AddRegularizePayloadType,
  GetSingleUserAttendanceReportDataPayloadType,
} from "../../commonTypes/timeSheetTypes";
import {
  GetAllFinacUserPayloadType,
  GetAttendanceTimePayloadType,
} from "../../commonTypes/authTypes";
import {
  getCurrentMonthDates,
  handleDate,
  reverseDateFormat,
} from "../../utils/commonFunctions";

import {
  CircularAvatar,
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../components/commons";
import ReportsDateSelect from "../../components/commons/ReportsDateSelect/ReportsDateSelect";
import { EmptyTimeSheetReportList } from "../../assets/images";
import {
  getAllFinacClientUsersAction,
  getAllFinacManagerAction,
  resetFinacManagerList,
  resetSession,
  userProfileAction,
} from "../../redux/auth";

import {
  addRegularizeAction,
  getSingleAttendanceDetailAction,
  getSingleUserAttendanceReportAction,
  resetSingleAttendaceReportList,
  resetSingleAttendanceDetail,
  resetTimeSheetError,
  resetTimeSheetMessage,
  resetTimeSheetStatusCode,
  resetTimeSheetSuccess,
} from "../../redux/timeSheet";
import { RootState } from "../../redux/rootReducers";
import CheckinCheckOutAttendanceTable from "../../components/MySpace/CheckinCheckOutAttendanceTable/CheckinCheckOutAttendanceTable";
import "./LoggedInUsersAttendanceReport.scss";
import RegularizeModal from "../../components/MySpace/RegularizeModal";
import useDebounce from "../../customHooks/useDebounce";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
import { LoginResponseType, UserProfileType } from "../../redux/auth/authTypes";
type AppProps = {
  token: string | null;
  fetching: boolean;
  message: string | null;
  error: string | null;
  statusCode: number | null;
  success: number | null;
  attendanceReportList: any;
  totalCount: number;
  totalUserCount: number | string | any;
  finacUsersList: any;
  userFetching: boolean;
  singleAttendanceDetail: any;
  finacManagerList: any;
  managerFetching: boolean;
  totalManagerCount: string | number;
  dispatchResetSession: () => void;
  dispatchResetTimeSheetError: () => void;
  dispatchResetTimeSheetSuccess: () => void;
  dispatchResetTimeSheetMessage: () => void;
  dispatchResetTimeSheetStatusCode: () => void;
  dispatchResetSingleAttendanceReportList: () => void;
  dispatchGetSingleAttendanceReportList: (
    data: GetSingleUserAttendanceReportDataPayloadType
  ) => void;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchGetSingleAttendanceDetailAction: (
    data: GetAttendanceTimePayloadType
  ) => void;
  dispatchResetAttendenceSingleDetailData: () => void;
  history: any;
  dispatchGetAllFinacManagerAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchAddRegularizeAction: (data: AddRegularizePayloadType) => void;
  dispatchUserProfileData: (data: any) => void;
  dispatchResetFinacManagerList: () => void;
  loginData: LoginResponseType;
  userProfileAllData?: UserProfileType;
};

export type DropDownItemType = {
  value: number | undefined;
  label: string | undefined;
};
export type ClientListType = {
  value: number | null;
  label: string | null;
};

const LoggedInUsersAttendanceReport = ({
  token,
  error,
  message,
  statusCode,
  success,
  fetching,
  attendanceReportList,
  dispatchResetSession,
  dispatchResetTimeSheetSuccess,
  dispatchResetTimeSheetError,
  dispatchResetTimeSheetMessage,
  dispatchResetTimeSheetStatusCode,
  dispatchGetSingleAttendanceReportList,
  dispatchResetSingleAttendanceReportList,
  history,
  managerFetching,
  finacManagerList,
  totalManagerCount,
  loginData,
  userProfileAllData,
  dispatchGetAllFinacManagerAction,
  dispatchResetFinacManagerList,
  dispatchAddRegularizeAction,
  dispatchUserProfileData,
}: AppProps) => {
  const { start, end } = getCurrentMonthDates();
  const [showRegularize, setShowRegularize] = useState(false);
  const [regularizeData, setRegularizeData] = useState(null);
  const redirectData = history?.location?.state;
  let isDefaultEmployee = (
    redirectData?.userProfileAllData?.job_details ||
    userProfileAllData?.job_details
  )?.find((jobDetails: any) => jobDetails?.is_default === true);

  const [showData, setShowData] = useState(false);
  const [userSelected, setUserSelected] = useState<any>({
    value: null,
    label: "Select User",
  });
  const [attendanceReportData, setAttendanceReportData] = useState([]);
  const [displayStartDate, setDisplayStartDate] = useState("");
  const [displayEndDate, setDisplayEndDate] = useState("");
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);
  const [toggle, setToggle] = useState<boolean>(false);
  const [finalManagerList, setFinalManagerList] = useState<any>([]);
  const [managerText, setManagerText] = useState<string>("");
  const [managerLimit, setManagerLimit] = useState<number>(20);
  const [managerOffset, setManagerOffset] = useState<number>(0);

  const search = useLocation().search;
  const notificationId = new URLSearchParams(search).get("notification_id");

  useEffect(() => {
    dispatchResetTimeSheetSuccess();
    dispatchResetTimeSheetError();
    dispatchResetTimeSheetMessage();
    dispatchResetTimeSheetStatusCode();
    dispatchResetFinacManagerList();
  }, []);

  // Manager List
  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: managerOffset,
        limit: managerLimit,
        user_type: "manager",
        status: 1,
        search_term: managerText,
      };
      if (managerOffset <= +totalManagerCount) {
        dispatchGetAllFinacManagerAction(finalUserData);
      }
    }
  }, [managerOffset]);

  const fetchNewManagerData = (search: string) => {
    const finalData = {
      token,
      offset: managerOffset,
      limit: managerLimit,
      user_type: "manager",
      status: 1,
      search_term: managerText,
    };
    dispatchGetAllFinacManagerAction(finalData);
  };

  useDebounce(
    () => {
      if (managerText) {
        fetchNewManagerData(managerText);
      } else {
        const finalData = {
          token,
          offset: managerOffset,
          limit: managerLimit,
          user_type: "manager",
          status: 1,
          search_term: managerText,
        };
        dispatchGetAllFinacManagerAction(finalData);
      }
    },
    500,
    [managerText]
  );

  useEffect(() => {
    const finalManagerData = finacManagerList?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name ? user?.first_name : ""} ${
          user?.last_name ? user?.last_name : ""
        } `,
        image: user?.profile_pic?.file_url,
      };
    });
    if (managerOffset > 0) {
      setFinalManagerList([...finalManagerList, ...finalManagerData]);
    } else {
      setFinalManagerList(finalManagerData);
    }
  }, [finacManagerList]);

  useEffect(() => {
    if (
      attendanceReportList &&
      attendanceReportList[0] &&
      attendanceReportList[0]?.data
    ) {
      let finalData: any = [...attendanceReportList[0]?.data]?.reverse();

      setAttendanceReportData(finalData);
    } else {
      setAttendanceReportData([]);
    }
  }, [attendanceReportList]);

  useEffect(() => {
    if (redirectData?.userId && redirectData?.name) {
      setUserSelected({
        value: redirectData?.userId,
        label: redirectData?.name,
      });
      handleSubmit(redirectData?.userId);
    }
  }, [redirectData]);

  useEffect(() => {
    if (loginData?.user_id && loginData?.first_name && notificationId) {
      setUserSelected({
        value: loginData?.user_id,
        label: `${loginData?.first_name} ${
          loginData?.last_name ? loginData?.last_name : ""
        }`,
      });
      handleSubmit(loginData?.user_id);
      let finalData = {
        token,
        user_id: loginData?.user_id,
      };
      dispatchUserProfileData(finalData);
    }
  }, [notificationId]);

  useEffect(() => {
    if (message === "Attendance regularize record sent successfully.") {
      toast.success("Attendance regularize record sent successfully.", {
        duration: 2000,
      });
      dispatchResetTimeSheetSuccess();
      dispatchResetTimeSheetError();
      dispatchResetTimeSheetMessage();
      dispatchResetTimeSheetStatusCode();
      if (loginData?.user_id) handleSubmit(loginData?.user_id);
    }
  }, [message]);

  const handleStartDateChange = (date: string) => {
    const value = handleDate(date);
    setStartDate(value);
  };
  const handleEndDateChange = (date: string) => {
    const value = handleDate(date);
    setEndDate(value);
  };

  const handleSubmit = (id: string | null | number) => {
    setShowData(true);
    dispatchResetSingleAttendanceReportList();
    if (token) {
      let finalData = {
        token,
        start_date: startDate ? reverseDateFormat(startDate) : "",
        end_date: endDate ? reverseDateFormat(endDate) : "",
        user_id: id,
        notificationId: notificationId ? notificationId : null,
      };
      dispatchGetSingleAttendanceReportList(finalData);
      setDisplayStartDate(handleDate(startDate));
      setDisplayEndDate(handleDate(endDate));
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
              dispatchResetTimeSheetSuccess();
              dispatchResetTimeSheetError();
              dispatchResetTimeSheetMessage();
              dispatchResetTimeSheetStatusCode();
            }}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetTimeSheetSuccess();
              dispatchResetTimeSheetError();
              dispatchResetTimeSheetMessage();
              dispatchResetTimeSheetStatusCode();
            }}
          />
        );
      }
    }

    return false;
  };

  const handleToggleSendRegularizeApprovalData = (data: any) => {
    setRegularizeData(data);
    setShowRegularize(!showRegularize);
  };
  const handleToggleSendRegularizeApproval = () => {
    setShowRegularize(!showRegularize);
  };

  const handleSubmitRegularizeInformation = (data: any) => {
    if (token) {
      const finalData = {
        token,
        ...data,
      };
      dispatchAddRegularizeAction(finalData);
    }
  };
  return (
    <>
      <div className="col-md-6">
        <CommonHeader title="My Attendance Report" />
      </div>
      <div className="col-md-12 mt-4">
        <div className="new-table-card">
          <div>
            <div className="d-flex align-items-start mt-3">
              <div className="w-10 pl-3 mt-3 d-flex flex-column p-0">
                <div className="d-flex align-items-center mt-2">
                  <CircularAvatar
                    name={
                      redirectData?.name ||
                      `${loginData?.first_name} ${
                        loginData?.last_name ? loginData?.last_name : ""
                      }`
                    }
                    image={
                      redirectData?.pic || loginData?.profile_pic?.file_url
                    }
                  />
                  <div>
                    <div className="ml-2" style={{ fontWeight: 500 }}>
                      {redirectData?.name ||
                        `${loginData?.first_name} ${
                          loginData?.last_name ? loginData?.last_name : ""
                        }`}
                    </div>
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#6e7491",
                      }}
                      className="ml-2"
                    >
                      {`${
                        isDefaultEmployee?.job_info?.job_title
                          ? isDefaultEmployee?.job_info?.job_title
                          : isDefaultEmployee?.job_info?.job_title
                          ? isDefaultEmployee?.job_info?.job_title
                          : ""
                      }${
                        isDefaultEmployee?.job_info?.department?.department_name
                          ? ","
                          : ""
                      } ${
                        isDefaultEmployee?.job_info?.department?.department_name
                          ? isDefaultEmployee?.job_info?.department
                              ?.department_name
                          : isDefaultEmployee?.job_info?.department
                              ?.department_name
                          ? isDefaultEmployee?.job_info?.department
                              ?.department_name
                          : ""
                      } `}
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-group ml-3">
                <label className="mb-1">
                  Date <span className="color-red">*</span>
                </label>
                <div className="attendance-report">
                  <ReportsDateSelect
                    setToggle={setToggle}
                    toggle={toggle}
                    startDate={startDate ? startDate : ""}
                    endDate={endDate ? endDate : ""}
                    handleStartDateChange={handleStartDateChange}
                    handleEndDateChange={handleEndDateChange}
                    type={"schedulingReport"}
                    minDate={"2023-12-01"}
                  />
                </div>
              </div>
              <div className="ml-3" style={{ marginTop: "29px" }}>
                <button
                  className="btn btn-primary pl-3 pb-2"
                  disabled={
                    !userSelected?.value ||
                    !startDate?.length ||
                    !endDate?.length
                  }
                  onClick={() => handleSubmit(userSelected?.value)}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
          {!fetching && (!showData || attendanceReportList?.length === 0) ? (
            <div className="pb-4 pl-0 pr-0 pt-4">
              <EmptyListPage
                title="No Attendance List Found!"
                imageWidth="30%"
                image={EmptyTimeSheetReportList}
                showAddButton={false}
              />
            </div>
          ) : fetching ? (
            <TableLoader Rows={7} ColumnPerRow={5} />
          ) : (
            <div>
              <CheckinCheckOutAttendanceTable
                data={attendanceReportData}
                handleToggleSendRegularizeApprovalData={
                  handleToggleSendRegularizeApprovalData
                }
              />
            </div>
          )}
        </div>
      </div>
      {showRegularize && (
        <RegularizeModal
          data={regularizeData}
          toggle={handleToggleSendRegularizeApproval}
          isOpen={showRegularize}
          finalManagerList={finalManagerList?.filter(
            (user: any) => user?.value !== loginData?.user_id
          )}
          managerFetching={managerFetching}
          setManagerOffset={setManagerOffset}
          setManagerText={setManagerText}
          managerLimit={managerLimit}
          handleSubmit={handleSubmitRegularizeInformation}
        />
      )}
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  error: state.timeSheet.error,
  statusCode: state.timeSheet.statusCode,
  success: state.timeSheet.success,
  message: state.timeSheet.message,
  fetching: state.timeSheet.fetching,
  totalCount: state.timeSheet.reportListCount,
  attendanceReportList: state.timeSheet.attendanceReportList,
  finacUsersList: state.auth.finacClientUsersList,
  totalUserCount: state.auth.totalUserCount,
  userFetching: state.auth.fetching,
  singleAttendanceDetail: state.timeSheet.singleAttendanceDetail,
  finacManagerList: state.auth.finacManagerList,
  managerFetching: state.auth.managerFetching,
  totalManagerCount: state.auth.totalManagerCount,
  loginData: state.auth.loginData,
  userProfileAllData: state.auth.userProfileAllData,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetTimeSheetSuccess: () => dispatch(resetTimeSheetSuccess()),
  dispatchResetTimeSheetError: () => dispatch(resetTimeSheetError()),
  dispatchResetTimeSheetMessage: () => dispatch(resetTimeSheetMessage()),
  dispatchResetTimeSheetStatusCode: () => dispatch(resetTimeSheetStatusCode()),
  dispatchResetSingleAttendanceReportList: () =>
    dispatch(resetSingleAttendaceReportList()),
  dispatchGetSingleAttendanceReportList: (
    data: GetSingleUserAttendanceReportDataPayloadType
  ) => dispatch(getSingleUserAttendanceReportAction(data)),
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacClientUsersAction(data)),
  dispatchGetSingleAttendanceDetailAction: (
    data: GetAttendanceTimePayloadType
  ) => dispatch(getSingleAttendanceDetailAction(data)),
  dispatchResetAttendenceSingleDetailData: () =>
    dispatch(resetSingleAttendanceDetail()),
  dispatchResetFinacManagerList: () => dispatch(resetFinacManagerList()),
  dispatchGetAllFinacManagerAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacManagerAction(data)),
  dispatchAddRegularizeAction: (data: AddRegularizePayloadType) =>
    dispatch(addRegularizeAction(data)),
  dispatchUserProfileData: (data: any) => dispatch(userProfileAction(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoggedInUsersAttendanceReport);
